import {
  type ContextType,
  type FC,
  type PropsWithChildren,
  createContext,
  useContext,
  useState,
} from 'react';

type SortingContextValue = {
  sorting: string;
  setSorting: (sorting: string) => void;
};

const Context = createContext<SortingContextValue | undefined>(undefined);

const _useContext = (): NonNullable<ContextType<typeof Context>> => {
  const context = useContext(Context);
  if (!context) {
    throw new Error('useSorting must be used within a TableSorterProvider.');
  }
  return context;
};

export const useSortingState = () => {
  return _useContext();
};

export const TableSorterProvider: FC<PropsWithChildren> = ({ children }) => {
  const [sorting, setSorting] = useState<string>('');

  return (
    <Context.Provider value={{ sorting, setSorting }}>
      {children}
    </Context.Provider>
  );
};
